<ng-container [formGroup]="form">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12 bold">
      <div class="section-header" [ngClass]="{ 'active' : true }" (click)="toggleOpen()">
        <span class="margin-right">Well Information</span>
        <button class="icon-button">
          @if (isOpen == false) {
            <svg-icon icon="icon-caret-right"></svg-icon>
          }
          @if (isOpen == true) {
            <svg-icon icon="icon-caret-down"></svg-icon>
          }
        </button>
      </div>
    </div>
  </div>
  <div class="grid-x margin-top" [ngClass]="{ 'hideSection': isOpen == false }">
    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Drilling Started:
      @if (fieldHasNotes('wellInfo|drillingStartDate') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|drillingStartDate'" [notes]="getFilteredNotes('wellInfo|drillingStartDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'drillingStartDate'" (dateUpdated)="onDateUpdated($event, 'drillingStartDate')" [initialDate]="drillingStartDate" [disabled]="form?.get('drillingStartDate')?.disabled"></common-date-picker>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Date Drilling Ended:
      @if (fieldHasNotes('wellInfo|drillingEndDate') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|drillingEndDate'" [notes]="getFilteredNotes('wellInfo|drillingEndDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <common-date-picker [id]="'drillingEndDate'" (dateUpdated)="onDateUpdated($event, 'drillingEndDate')" [initialDate]="drillingEndDate" [disabled]="form?.get('drillingEndDate')?.disabled"></common-date-picker>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Deepest Formation:
      @if (fieldHasNotes('wellInfo|deepestFormation') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|deepestFormation'" [notes]="getFilteredNotes('wellInfo|deepestFormation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <select formControlName="deepestFormation">

        @for (formation of formations; track formation) {
          <option [value]="formation.code">{{formation.definition}}</option>
        }
      </select>

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Driller Total Depth:
      @if (fieldHasNotes('wellInfo|drillerTotalDepth') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|drillerTotalDepth'" [notes]="getFilteredNotes('wellInfo|drillerTotalDepth')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="number" formControlName="drillerTotalDepth" />

    </div>

    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Logger Total Depth:
      @if (fieldHasNotes('wellInfo|loggerTotalDepth') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|loggerTotalDepth'" [notes]="getFilteredNotes('wellInfo|loggerTotalDepth')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="number" formControlName="loggerTotalDepth" />

    </div>


    <div class="cell small-7 large-7 medium-7 bold padding-right">
      Drilling Contractor
      @if (fieldHasNotes('wellInfo|drillingContractor') || reviewStates?.includes(applicationState)) {
        <span class="padding-left">
          <view-notes [fieldName]="'wellInfo|drillingContractor'" [notes]="getFilteredNotes('wellInfo|drillingContractor')" (notesRequested)="handleNoteRequested($event)"></view-notes>
        </span>
      }
    </div>
    <div class="cell small-2 large-2 medium-2">

      <input type="text" formControlName="drillingContractor" />

    </div>


    <div class="grid-x cell">
      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Elevation - Ground Level:
        @if (fieldHasNotes('wellInfo|groundLevel') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'wellInfo|groundLevel'" [notes]="getFilteredNotes('wellInfo|groundLevel')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell small-2 large-2 medium-2">

        <input type="number" formControlName="groundLevel" />

      </div>

      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Elevation - Derrick Floor:
        @if (fieldHasNotes('wellInfo|derrickFloor') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'wellInfo|derrickFloor'" [notes]="getFilteredNotes('wellInfo|derrickFloor')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell small-2 large-2 medium-2">

        <input type="number" formControlName="derrickFloor" />

      </div>

      <div class="cell small-7 large-7 medium-7 bold padding-right">
        Elevation - Kelly Bushing:
        @if (fieldHasNotes('wellInfo|kellyBushing') || reviewStates?.includes(applicationState)) {
          <span class="padding-left">
            <view-notes [fieldName]="'wellInfo|kellyBushing'" [notes]="getFilteredNotes('wellInfo|kellyBushing')" (notesRequested)="handleNoteRequested($event)"></view-notes>
          </span>
        }
      </div>
      <div class="cell small-2 large-2 medium-2">

        <input type="number" formControlName="kellyBushing" />

      </div>
    </div>


  </div>
</ng-container>
